import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api';

/** Öffnet einen geteilten Runden-Link (/join/:code) und tritt automatisch bei. */
export function JoinPage() {
  const { code = '' } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api.rounds
      .join(code)
      .then((res) => navigate(`/round/${res.round.id}`, { replace: true }))
      .catch((err) => setError(err instanceof ApiError ? t('challenge.notFound') : t('errors.generic')));
  }, [code, navigate, t]);

  return (
    <div className="container page center stack" style={{ alignItems: 'center', marginTop: '12vh' }}>
      {error ? (
        <>
          <div className="notice notice-error">{error}</div>
          <button className="btn" onClick={() => navigate('/')}>{t('result.backToDirectory')}</button>
        </>
      ) : (
        <>
          <div className="spinner" />
          <p className="muted">{t('challenge.joining', { code })}</p>
        </>
      )}
    </div>
  );
}
